//const API_BASE_URL = "https://easy-apt-api-225686869543.asia-south2.run.app/api"; // Replace with your actual backend URL
const API_BASE_URL = "https://easy-apt-api-1005185106929.asia-south2.run.app/api"; // New
//const API_BASE_URL = "http://localhost:8080/api";
// Assuming your backend is running on localhost:8080 and API prefix is /api

const apiService = {
  async request(
    method: string,
    url: string,
    data?: any,
    headers?: HeadersInit,
  ) {
    const token = localStorage.getItem("token"); // Assuming token is stored in localStorage
    const defaultHeaders: HeadersInit = {
      // Only set Content-Type for JSON by default. For FormData, it will be handled by the browser.
      ...(data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    };

    // --- Debugging additions ---
    //console.groupCollapsed(`API Request: ${method} ${API_BASE_URL}${url}`);
    //console.log("Full URL:", `${API_BASE_URL}${url}`);
    // console.log("Method:", method);
    //console.log("Request Headers:", defaultHeaders);
    if (data && !(data instanceof FormData)) {
      //console.log("Request Body:", data);
    }
    console.groupEnd();
    // --- End debugging additions ---

    const config: RequestInit = {
      method,
      headers: defaultHeaders,
    };

    if (data && method !== "GET" && method !== "HEAD") {
      config.body = data instanceof FormData ? data : JSON.stringify(data);
    }

    try {
      const response = await fetch(`${API_BASE_URL}${url}`, config);

      // Handle 204 No Content responses, which have no body to parse
      if (response.status === 204) {
        return response;
      }

      // // --- Added for debugging ---
      // console.groupCollapsed(
      //   `API Response: ${method} ${API_BASE_URL}${url} - Status: ${response.status}`,
      // );
      // console.log("Response Status:", response.status);
      // console.log("Response Status Text:", response.statusText);
      // console.log(
      //   "Response Headers:", // This was previously uncommented, ensuring it's commented now.
      //   Object.fromEntries(response.headers.entries()),
      // );
      if (!response.ok) {
        const errorBody = await response.clone().text(); // Use text() to avoid JSON parsing errors
        console.error("Error Response Body:", errorBody);
      }
      console.groupEnd();
      // --- End debugging additions ---

      if (response.status === 401) {
        // // Unauthorized: Token expired or invalid.
        // console.error(
        //   "Unauthorized: Token expired or invalid. Redirecting to login.",
        // );
        localStorage.removeItem("token");
        // Redirect to the login page using a relative path.
        // In a React application, consider using `useNavigate` from `react-router-dom` for better integration.
        window.location.href = "/auth-pages/login";
        // Return a new Response object to prevent further processing in the calling component
        // and to indicate that the request failed due to authorization.
        return new Response(null, { status: 401, statusText: "Unauthorized" });
      }

      return response;
    } catch (error) {
      console.error(
        "Network error for request:",
        `${API_BASE_URL}${url}`,
        error,
      );
      throw error; // Re-throw to allow component-specific error handling if needed
    }
  },

  get(url: string, headers?: HeadersInit) {
    return this.request("GET", url, undefined, headers);
  },

  post(url: string, data: any, headers?: HeadersInit) {
    return this.request("POST", url, data, headers);
  },

  put(url: string, data: any, headers?: HeadersInit) {
    return this.request("PUT", url, data, headers);
  },

  delete(url: string, headers?: HeadersInit) {
    return this.request("DELETE", url, undefined, headers);
  },

  patch(url: string, data: any, headers?: HeadersInit) {
    return this.request("PATCH", url, data, headers);
  },
};

export default apiService;
